const initState = {
    fetching: false,
    settings:{}
}

const SettingsDataReducer = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_SETTINGS_DATA':
            return {
                ...state,
                fetching_settings_data: true,
                error: ""
            }

        case 'FETCH_SETTINGS_DATA_SUCCESSFUL':
            return {
                ...state,
                fetching_settings_data: false,
                settings: action.settings
            }
        
        default:
            return state;
    }

}

export default SettingsDataReducer;